import { computed, isRef } from "vue";

export function useTask(task = null) {
    const _task = computed(() => (isRef(task) ? task.value : task));

    function getTimeLogged(task = null) {
        if (!task) {
            task = _task.value;
        }
        return task.time?.reduce((acc, time) => {
            const duration =
                new Date(time.end).getTime() - new Date(time.start).getTime();
            return acc + duration / 1000;
        }, 0);
    }

    function getMaterialCost(task = null) {
        if (!task) {
            task = _task.value;
        }

        return task.material?.reduce((acc, material) => {
            return acc + material.cost;
        }, 0);
    }

    function getBreadcrumb(task = null) {
        if (!task) {
            task = _task.value;
        }

        let items = [];

        items.push({
            id: task.tenant.id,
            label: task.tenant.name,
            type: "tenant",
        });

        task.spaces.forEach((space) => {
            items.push({
                id: space.id,
                label: space.name,
                type: "space",
            });
        });

        return items;
    }

    return {
        getTimeLogged,
        getMaterialCost,
        getBreadcrumb,
    };
}
